var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Field } from 'react-final-form';
import { StyledInputLabel, InputElementHeading } from '../elements';
import { Input } from '../input/input';
import { useEffect } from 'react';
import AccessibilityHelper from '../accessibilityHelper';
var InputText = React.forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, name = _a.name, ariaLabel = _a.ariaLabel, hint = _a.hint, input = _a.input, inputClassName = _a.inputClassName, testId = _a.testId, meta = _a.meta, required = _a.required, placeholder = _a.placeholder, disabled = _a.disabled, readOnly = _a.readOnly, autoComplete = _a.autoComplete, cfg = _a.cfg, updatedValue = _a.updatedValue, maxLength = _a.maxLength, wrapperElement = _a.wrapperElement, labelElement = _a.labelElement, headingElement = _a.headingElement, onKeyPress = _a.onKeyPress;
    useEffect(function () {
        if (typeof updatedValue !== 'undefined') {
            input.onChange(updatedValue);
        }
    }, [updatedValue]);
    var helper = new AccessibilityHelper(name, !!label, !!hint);
    var labelRequiresForAttribute = labelElement && labelElement.toUpperCase() === 'LABEL';
    if (labelRequiresForAttribute && !id) {
        throw 'id is required when setting labelElement="label"';
    }
    var InputElementHeadingWrapper = headingElement
        ? headingElement
        : React.Fragment;
    return (React.createElement(StyledInputLabel, { isError: meta && meta.touched && meta.error, element: wrapperElement, cfg: Object.assign({ mt: 1 }, cfg) },
        React.createElement(InputElementHeadingWrapper, null,
            React.createElement(InputElementHeading, { element: labelElement, label: label, required: required, hint: hint, meta: meta, accessibilityHelper: helper, forId: labelRequiresForAttribute ? id : undefined })),
        React.createElement(Input, __assign({ id: id, ref: ref, type: "text", testId: testId, label: ariaLabel ? ariaLabel : label, placeholder: placeholder, disabled: disabled, readOnly: readOnly, autoComplete: autoComplete, isError: meta && meta.touched && meta.error, className: inputClassName, maxLength: maxLength, accessibilityHelper: helper, required: required, onKeyPress: onKeyPress }, input))));
});
export var FFInputText = React.forwardRef(function (fieldProps, ref) {
    return (React.createElement(Field, __assign({}, fieldProps, { required: fieldProps.required, ref: ref, render: function (props) { return React.createElement(InputText, __assign({}, props, fieldProps, { ref: ref })); } })));
});
//# sourceMappingURL=text.js.map